import { useMemo } from "react";

/**
 * Hook de calcul du profil de pricing
 * Source unique de vérité pour transformer le userProfil en data pricing
 */
export const useProfilPricing = (userProfil) => {
  const profilPricing = useMemo(() => {
    if (!userProfil) return null;

    return {
      isAdmin: userProfil.role === "admin",
      isCollaborator:
        userProfil.role === "collaborateur" || userProfil.role === "staff",
      discountRate: userProfil.discount || 0,
      type_profil: userProfil.role || "client",
    };
  }, [userProfil]);

  return profilPricing;
};
